import React, { useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import LeaderFranchise from 'app/fuse-layouts/shared-components/LeaderFranchise';
import { useSelector } from 'react-redux';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@material-ui/icons';
import {
  Button,
  Typography,
  withStyles
} from '@material-ui/core';
import HairdresserPopover from 'app/main/components/models/Hairdresser/HairdresserPopover';
import { UserService } from 'app/services/userService';
import userRoles from 'app/userRoles';
import { Link } from 'react-router-dom';
import {
  StoreIcon,
  MinisiteIcon,
  SurveyIcon,
} from 'app/main/components/icons';
import useAxiosGet from 'hooks/useAxiosGet';
import { useTranslation } from 'react-i18next';
import HelpBtn from 'app/main/components/Btns/HelpBtn';
import SearchButtonModalDesk from './SearchButtonModalDesk';

const useStyles = makeStyles(theme => ({
  franchiseLeaderButton: {
    color: theme.palette.text.dynamic
  },
  franchiseLeaderContainer: {
    display: 'flex',
    marginLeft: 20,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      flexDirection: 'column'
    }
  },
  franchiseLeaderIcon: {
    fontSize: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: 19
    }
  },
  franchiseLeaderText: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 5,
    textAlign: 'left'
  },
  franchiseLeader: {
    fontFamily: 'Sofia-pro',
    fontWeight: 100,
    fontSize: '1.5rem'
  },
  franchiseLeaderName: {
    fontFamily: 'Sofia-pro',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem'
    }
  },
  separator: {
    width: 1,
    height: 64,
    backgroundColor: theme.palette.divider
  },
  hairdresserSelectedContainer: {
    display: 'flex',
    alignItems: 'center',
    color: `${theme.palette.text.dynamic}!important`,
    textDecoration: 'none!important',
    marginLeft: theme.spacing(2),
    '&:hover': {
      borderRadius: 5
    },
    [theme.breakpoints.down('sm')]: {
      '& .MuiButton-endIcon': {
        display: 'none'
      },
      '& .MuiButton-label': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      },
      '& .MuiButton-startIcon': {
        marginRight: 'initial'
      }
    }
  },
  haidresserSelectedTypographyPrimary: {
    fontWeight: 700
  },
  hairdresserSelectedIcon: {
    fontSize: '28px !important',
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginRight: 'initial',
      width: 23,
      height: 23
    }
  }
}));

const StyledButton = withStyles(theme => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      minWidth: '50px !important',
      marginLeft: theme.spacing(0.5),
      '& .MuiTypography-root': {
        display: 'none'
      }
    }
  }
}))(Button);

function ToolbarLayout1() {
  const { t } = useTranslation();
  const user = useSelector(({ auth }) => auth.user);
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
  const [anchorEl, setAnchorEl] = useState(null);
  const [{ data: hairdressersMe }] = useAxiosGet('/hairdressers', {
    ignoreCache: true
  });
  const classes = useStyles();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const userFromLocalStorage = localStorage.getItem('user');
  const userLS = JSON.parse(userFromLocalStorage);
  const acceptCgu = userLS?.accept_cgu;
  // const acceptCgu = "2024-02-01 00:00:00";
  // owner is in the local storage during interpretation, meaning we don't want to show the TOU when an admin is emulating an other user
  const ownerFromLocalStorage = localStorage?.getItem('owner');
  const ownerLS = JSON.parse(ownerFromLocalStorage);

  return (
    <AppBar id="fuse-toolbar" className="flex relative z-10" color="primary">
      <Toolbar className="p-0">
        <Hidden mdDown>
          <LeaderFranchise name="Gilles Dupont" />
        </Hidden>
        {config.navbar.display && config.navbar.position === 'left' && (
          <Hidden lgUp>
            <NavbarMobileToggleButton className="w-64 h-64 p-0" />
            <div className={classes.separator} />
          </Hidden>
        )}
        {UserService.isFranchise(user) && (
          <Hidden lgUp>
            <LeaderFranchise name="Contact" />
          </Hidden>
        )}
        <div
          className="flex flex-1"
          style={{
            alignItems: 'center',
            gap: '1rem'
          }}
        >
          {window.location.pathname !== '/login' &&
            window.location.pathname !== '/forgot-password' &&
            (acceptCgu || ownerLS) && <SearchButtonModalDesk />}
        </div>
        <div className="flex" style={{alignItems: 'center'}}>
          <HelpBtn />
          {((user && acceptCgu) || ownerLS) &&
            (user.countries?.includes(1) || // France
              user.countries?.includes(2) || // Belgique
              user.countries?.includes(12) || // Suisse
              user.countries?.includes(21) || // Guadeloupe
              user.countries?.includes(31) || // Reunion
              user.countries?.includes(106) || // Guyane
              user.countries?.includes(169)) && ( // Martinique
              <StyledButton
                className={classes.hairdresserSelectedContainer}
                href="https://my.forms.app/provalliance-digital/anniversaire-connect"
                target="_blank"
                size="small"
              >
                <SurveyIcon className={classes.hairdresserSelectedIcon} />
                <Typography
                  style={{ fontSize: '1.5rem', fontFamily: 'sofia-pro' }}
                >
                  {t('hairdressers.survey')}
                </Typography>
              </StyledButton>
            )}
          {((user && acceptCgu) || ownerLS) &&
            UserService.hasSomeRoles(user, [userRoles.ROLE_SUPER_ADMIN]) && (
              <StyledButton
                className={classes.hairdresserSelectedContainer}
                component={Link}
                to="/hairdressers"
                size="small"
              >
                <StoreIcon className={classes.hairdresserSelectedIcon} />
                <Typography
                  style={{ fontSize: '1.5rem', fontFamily: 'sofia-pro' }}
                >
                  {t('hairdressers.hairdressers')}
                </Typography>
              </StyledButton>
            )}
          {((user && acceptCgu) || ownerLS) &&
            hairdressersMe &&
            !UserService.hasSomeRoles(user, [userRoles.ROLE_SUPER_ADMIN]) &&
            hairdressersMe.length > 1 && (
              <>
                <StyledButton
                  className={classes.hairdresserSelectedContainer}
                  startIcon={
                    <StoreIcon className={classes.hairdresserSelectedIcon} />
                  }
                  endIcon={
                    !open ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />
                  }
                  onClick={handleClick}
                  size="small"
                >
                  {user?.hairdresserSelected ? (
                    <div className="text-left">
                      <Hidden smDown>
                        <Typography
                          className={
                            classes.haidresserSelectedTypographyPrimary
                          }
                        >
                          {user.hairdresserSelected.brands?.name}
                        </Typography>
                        <Typography>
                          {`${
                            user.hairdresserSelected.code !== null
                              ? `${user.hairdresserSelected.code} - `
                              : ''
                          } ${user.hairdresserSelected.name}`}
                        </Typography>
                      </Hidden>
                      <Hidden mdUp>
                        <Typography
                          style={{
                            fontSize: '1.5rem',
                            fontFamily: 'sofia-pro'
                          }}
                        >
                          {t('hairdressers.hairdressers')}
                        </Typography>
                      </Hidden>
                    </div>
                  ) : (
                    <Typography
                      style={{ fontSize: '1.5rem', fontFamily: 'sofia-pro' }}
                    >
                      {t('hairdressers.hairdressers')}
                    </Typography>
                  )}
                </StyledButton>
                <HairdresserPopover
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                />
              </>
            )}
          {((user && acceptCgu) || ownerLS) &&
            !UserService.hasSomeRoles(user, [userRoles.ROLE_SUPER_ADMIN]) &&
            hairdressersMe?.length === 1 &&
            user.hairdresserSelected && (
              <StyledButton
                className={classes.hairdresserSelectedContainer}
                component={Link}
                to={`/hairdresser/minisite/${user.hairdresserSelected.id}?tab=parameters`}
                size="small"
                startIcon={
                  <>
                    <Hidden mdUp>
                      <MinisiteIcon
                        className={classes.hairdresserSelectedIcon}
                      />
                    </Hidden>
                    <Hidden mdDown>
                      <StoreIcon className={classes.hairdresserSelectedIcon} />
                    </Hidden>
                  </>
                }
              >
                <div>
                  <Hidden mdUp>
                    <Typography
                      style={{ fontSize: '1.5rem', fontFamily: 'sofia-pro' }}
                    >
                      Minisite
                    </Typography>
                  </Hidden>
                  <Hidden mdDown>
                    <Typography
                      className={classes.haidresserSelectedTypographyPrimary}
                    >
                      {user.hairdresserSelected.brands?.name}
                    </Typography>
                    <Typography>
                      {`${
                        user.hairdresserSelected.code !== null
                          ? `${user.hairdresserSelected.code} - `
                          : ''
                      } ${
                        user.hairdresserSelected.name !== ''
                          ? user.hairdresserSelected.name
                          : user.hairdresserSelected.city
                      } - ${user.hairdresserSelected.countries?.iso2}`}
                    </Typography>
                  </Hidden>
                </div>
              </StyledButton>
            )}
          <UserMenu />
        </div>

        {config.navbar.display && config.navbar.position === 'right' && (
          <Hidden lgUp>
            <NavbarMobileToggleButton />
          </Hidden>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default React.memo(ToolbarLayout1);
